import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderServiceService} from '../order-service/order-service.service';
import {DeviceTypeService} from '../../device-type/device-type.service';
import {ToastrService} from 'ngx-toastr';
import {forEach} from 'typescript-collections/dist/lib/arrays';
import {PackageServiceService} from '../../package/service/package-service.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-provision-form',
  templateUrl: './provision-form.component.html',
  styleUrls: ['./provision-form.component.css']
})
export class ProvisionFormComponent implements OnInit {
  provisionDetailsForm: FormGroup;
  provisionOrderForm: FormGroup;
  id: [];
  orderId: any;
  clientNumber: any;
  orderNumber: any;
  series = [];
  items = [];
  orderItems: any [];
  loading: boolean;
  submitted: boolean;
  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private orderService: OrderServiceService,
              private packageService: PackageServiceService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.route.params.subscribe(routeParams => {this.orderId = routeParams.orderIdParam; });
    this.route.params.subscribe(routeParams => {this.clientNumber = routeParams.clientNumberParam; });
    this.route.params.subscribe(routeParams => {this.orderNumber = routeParams.orderNumberParam; });
    this.provisionDetailsForm = this._formBuilder.group({
      id: [''],
      quantity: [''],
      prefferedPackage: ['']
    });

    this.provisionOrderForm = this._formBuilder.group({
      items: this._formBuilder.array([{
        id: [''],
        quantity: [''],
        prefferedPackages: ['']
      }]),
    });
  }

  ngOnInit() {
    this.getClientOrder(this.orderId);
  }

  generateSequenc(num) {
    this.series = [];
  for (let i = 1 ; i <= num; i++) {
    this.series.push(i);
    }
  return this.series;
  }

  createProvision(provisionOrderForm) {
    console.log(provisionOrderForm);
  }
  provision(provisionDetailsForm, deviceType) {
    const items = this.provisionOrderForm.get('items').value;
    this.provisionOrderForm.get('items').value[0].id =  deviceType;
    this.provisionOrderForm.get('items').value[0].quantity =  provisionDetailsForm.value.quantity;
    if (provisionDetailsForm.value.prefferedPackage !== '') {
    this.provisionOrderForm.get('items').value[0].prefferedPackages =  provisionDetailsForm.value.prefferedPackage;
    } else {
      this.provisionOrderForm.get('items').value[0].prefferedPackages =  [];
    }
    /*
    // items[0].id = provisionDetailsForm.value.id;
      items[0].quantity = provisionDetailsForm.value.quantity;
      items[0].prefferedPackage = provisionDetailsForm.value.prefferedPackage;
*/
    console.log(this.provisionOrderForm.get('items').value);
    this.loading = true;
    this.submitted = true;
    this.orderService.createProvision(this.provisionOrderForm.value, this.orderId)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Order Provisioned successfully');
            this.router.navigate(['/elasticcare/order']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });


  }
  getClientOrder(orderId) {
    this.loading = true;
    this.orderService.getOrder(orderId)
        .subscribe(data => {
          if (data.status === 200) {
            const response: any = data.json();
            this.orderItems = response.orderItems.itemsList;
            for (let i = 0; i < this.orderItems.length ; i++) {
              const sequence = this.generateSequenc(this.orderItems[i].quantity);
              this.orderItems[i].noOfPackages = sequence;
             // this.orderItems[i].prefferedPackages = this.getAllAvailablePackages(i, this.orderItems[i].deviceType);
              this.getAllAvailablePackages(i, this.orderItems[i].deviceType);
            }
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }


  getAllAvailablePackages(index, deviceId) {
    this.loading = true;
    this.packageService.getAllPackages('', 'AVAILABLE', '' , '', deviceId)
        .subscribe(data => {
          const response: any = data.json();
          console.log(response.packages);
          this.orderItems[index].prefferedPackages = response.packages;
          this.orderItems[index].availablePackages = response.numberOfPackages;
        }, (error) => {
          this.loading = false;
        });

  }
}
